/* eslint-disable no-unused-vars */

import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useEffect, useCallback } from 'react';
import OperationLog from './components/OperationLog';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ol/getLog'];
  const datas = useSelector((state) => state.ol.logList);

  // 获取会员列表
  const fetchData = useCallback(() => {
    console.log(props.location);
    if (props.location.query.id) {
      dispatch({
        type: 'ol/getLog',
        payload: {
          values: props.location.query.id,
        },
      });
    }
  }, [dispatch]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  let tableData = datas || [];

  return (
    <div className={styles.mm_content}>
      <div className={classnames(styles.table_page, styles.single_component)}>
        <OperationLog loading={loading} tableData={tableData} />
      </div>
    </div>
  );
};

export default MemberManagement;
